import config from "@/config"
import http from "@/utils/request"

export default {
  dic: {
    tree: {
      url: `${config.API_URL}/dic`,
      name: "获取字典树",
      get: async function () {
        return await http.post(this.url, { auth: false, method: 'get.dic.select', type: 1 });
      }
    },
    list: {
      url: `${config.API_URL}/dic`,
      name: "字典明细列表",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.dic.list', ...data });
      }
    },
    select: {
      url: `${config.API_URL}/dic`,
      name: "字典明细列表(不分页)",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.dic.select', ...data });
      }
    },
    get: {
      url: `${config.API_URL}/dic`,
      name: "获取字典数据",
      get: async function (params) {
        return await http.post(this.url, { auth: false, method: 'get.dic.item', ...params });
      }
    },
    add: {
      url: `${config.API_URL}/dic`,
      name: "获取字典数据",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'add.dic.item', ...data });
      }
    },
    edit: {
      url: `${config.API_URL}/dic`,
      name: "获取字典数据",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.dic.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/dic`,
      name: "获取字典数据",
      post: async function (dic_id, status) {
        return await http.post(this.url, { auth: false, method: 'set.dic.status', dic_id, status });
      }
    },
    delete: {
      url: `${config.API_URL}/dic`,
      name: "获取字典数据",
      post: async function (dic_id) {
        return await http.post(this.url, { auth: false, method: 'del.dic.list', dic_id });
      }
    },
    alias: {
      url: `${config.API_URL}/dic`,
      name: "获取字典数据",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.dic.alias', ...data });
      }
    }
  },
  role: {
    add: {
      url: `${config.API_URL}/auth_group`,
      name: "新增一个角色",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'add.auth.group.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/auth_group`,
      name: "编辑一个角色",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.auth.group.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/auth_group`,
      name: "编辑一个角色状态",
      post: async function (group_id, status) {
        return await http.post(this.url, { auth: false, method: 'set.auth.group.status', group_id, status });
      }
    },
    delete: {
      url: `${config.API_URL}/auth_group`,
      name: "删除一个角色",
      post: async function (group_id) {
        return await http.post(this.url, { auth: false, method: 'del.auth.group.item', group_id });
      }
    },
    setRule: {
      url: `${config.API_URL}/auth_rule`,
      name: "设置角色权限",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.auth.rule.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/auth_group`,
      name: "获取角色列表",
      get: async function (params) {
        return await http.post(this.url, { auth: false, method: 'get.auth.group.list', ...params });
      }
    }
  },
  dept: {
    add: {
      url: `${config.API_URL}/dept`,
      name: "新增一个员工",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'add.dept.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/dept`,
      name: "编辑一个员工",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.dept.item', ...data });
      }
    },
    del: {
      url: `${config.API_URL}/dept`,
      name: "编辑一个员工",
      post: async function (dept_id) {
        return await http.post(this.url, { auth: false, method: 'del.dept.list', dept_id });
      }
    },
    list: {
      url: `${config.API_URL}/dept`,
      name: "获取部门列表",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.dept.list', ...data });
      }
    },
    item: {
      url: `${config.API_URL}/dept`,
      name: "获取部门列表",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.dept.item', ...data });
      }
    }
  },
  log: {
    list: {
      url: `${config.API_URL}/action_log`,
      name: "日志列表",
      get: async function (params) {
        return await http.post(this.url, { auth: false, method: 'get.action.log.list', ...params });
      }
    }
  },
  tasks: {
    list: {
      url: `${config.API_URL}/system/tasks/list`,
      name: "系统任务管理",
      get: async function (params) {
        return await http.get(this.url, params);
      }
    }
  },
  richtext: {
    add: {
      url: `${config.API_URL}/richtext`,
      name: "新增一个富文本",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'add.richtext.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/richtext`,
      name: "编辑一个富文本",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.richtext.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/richtext`,
      name: "批量编辑富文本状态",
      post: async function (richtext_id, status) {
        return await http.post(this.url, { auth: false, method: 'set.richtext.status', richtext_id, status });
      }
    },
    delete: {
      url: `${config.API_URL}/richtext`,
      name: "批量删除富文本",
      post: async function (richtext_id) {
        return await http.post(this.url, { auth: false, method: 'del.richtext.list', richtext_id });
      }
    },
    item: {
      url: `${config.API_URL}/richtext`,
      name: "获取一个富文本详情",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.richtext.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/richtext`,
      name: "获取富文本列表",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.richtext.list', ...data });
      }
    }
  },
  ads_position: {
    add: {
      url: `${config.API_URL}/ads_position`,
      name: "新增一个广告位",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'add.ads_position.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/ads_position`,
      name: "编辑一个广告位",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.ads_position.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/ads_position`,
      name: "批量编辑广告位状态",
      post: async function (ads_position_id, status) {
        return await http.post(this.url, { auth: false, method: 'set.ads_position.status', ads_position_id, status });
      }
    },
    delete: {
      url: `${config.API_URL}/ads_position`,
      name: "批量删除广告位",
      post: async function (ads_position_id) {
        return await http.post(this.url, { auth: false, method: 'del.ads_position.list', ads_position_id });
      }
    },
    item: {
      url: `${config.API_URL}/ads_position`,
      name: "获取一个广告位详情",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.ads_position.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/ads_position`,
      name: "获取广告位列表",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.ads_position.list', ...data });
      }
    }
  },
  ads: {
    add: {
      url: `${config.API_URL}/ads`,
      name: "新增一个广告列",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'add.ads.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/ads`,
      name: "编辑一个广告列",
      post: async function (data) {
        return await http.post(this.url, { auth: false, method: 'set.ads.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/ads`,
      name: "批量编辑广告列状态",
      post: async function (ads_id, status) {
        return await http.post(this.url, { auth: false, method: 'set.ads.status', ads_id, status });
      }
    },
    sort: {
      url: `${config.API_URL}/ads`,
      name: "批量编辑广告列排序",
      post: async function (ads_id, sort) {
        return await http.post(this.url, { auth: false, method: 'set.ads.sort', ads_id, sort });
      }
    },
    delete: {
      url: `${config.API_URL}/ads`,
      name: "批量删除广告列",
      post: async function (ads_id) {
        return await http.post(this.url, { auth: false, method: 'del.ads.list', ads_id });
      }
    },
    item: {
      url: `${config.API_URL}/ads`,
      name: "获取一个广告列详情",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.ads.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/ads`,
      name: "获取广告列列表",
      get: async function (data) {
        return await http.post(this.url, { auth: false, method: 'get.ads.list', ...data });
      }
    }
  },

}
